<div class="parent">
  <div class="edit-text-modal-header" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
    <mode-dialog-header>
      <h1 heading>Text Settings</h1>
      <div sub-heading class="sub-header"><span class="sub-header-field">Field:</span>{{ fieldName }}</div>
    </mode-dialog-header>
  </div>
  <div class="content-container">
    <div class="section-label">Apply text labels to the following values:</div>
    <div class="all-values-check-field">
      <ng-container
        *ngTemplateOutlet="
          optionCheckField;
          context: { id: MarkOptions.All, label: 'All values', isChecked: isShowAll, isDisabled: false }
        "
      ></ng-container>
    </div>
    <ng-container
      *ngTemplateOutlet="
        optionCheckField;
        context: { id: MarkOptions.First, label: 'First', isChecked: isShowFirst, isDisabled: isShowAll }
      "
    ></ng-container>
    <ng-container
      *ngTemplateOutlet="
        optionCheckField;
        context: { id: MarkOptions.Last, label: 'Last', isChecked: isShowLast, isDisabled: isShowAll }
      "
    ></ng-container>
    <ng-container
      *ngTemplateOutlet="
        optionCheckField;
        context: { id: MarkOptions.Min, label: 'Minimum', isChecked: isShowMin, isDisabled: isShowAll }
      "
    ></ng-container>
    <ng-container
      *ngTemplateOutlet="
        optionCheckField;
        context: { id: MarkOptions.Max, label: 'Maximum', isChecked: isShowMax, isDisabled: isShowAll }
      "
    ></ng-container>
  </div>
  <div class="exclude-text-container">
    <span class="exclude-text-label">Exclude overlapping text labels</span>
    <mode-toggle-switch
      [state]="useLabelThinning"
      (stateChange)="setUseLabelThinning($event)"
      data-test="toggle-exclude-overlapping"
    ></mode-toggle-switch>
  </div>

  <div mat-dialog-actions>
    <div class="actions-left">
      <capra-button class="action" text="Reset" variant="secondary" color="neutral" (clicked)="reset()"></capra-button>
    </div>
    <div class="actions-right">
      <capra-button class="action" text="Apply" variant="secondary" color="neutral" (clicked)="updateChart(false)"></capra-button>
      <capra-button class="action" text="Apply and close" (click)="updateChart(true)"></capra-button>
    </div>
  </div>
</div>
<ng-template #optionCheckField let-id="id" let-label="label" let-isChecked="isChecked" let-isDisabled="isDisabled">
  <div class="check-field">
    <span class="checkbox-icon marks-checkbox-icon">
      <input
        type="checkbox"
        id="{{ id }}"
        [checked]="isChecked"
        [value]="isChecked"
        [disabled]="isDisabled"
        (change)="onCheckBoxChange(id, $event)"
      />
      <label class="inline-icon icon-editor-checkbox-light-unchecked" for="{{ id }}" [class.disabled]="isDisabled">{{
        label
      }}</label>
    </span>
  </div>
</ng-template>
